import React from 'react';
import DynamicLabelInput from './DynamicLabelInput';

const renderField = ({ input, label, showSuccess, type, maxLength, autoComplete, meta: { asyncValidating, touched, error, valid, invalid, warning } }) => (
  <div className={`form-group ${touched && invalid ? 'has-error' : ''} ${touched && valid && showSuccess ? 'has-success' : ''}`}>
    <div className={asyncValidating ? 'async-validating' : ''}>
        <DynamicLabelInput {...input} 
        	className="form-control" 
        	showLabel={['montemar', 'montemar-adelantos', 'amfa', 'ftyc', 'juncal'].includes(process.env.PAGE)}
        	placeholder={label} 
            type={type}
            maxLength={maxLength}
        	autoComplete={autoComplete}/>
        <div className="help-block">
        {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
  </div>
)

export default renderField;


/** WEBPACK FOOTER **
 ** ./src/components/RenderField.js
 **/